module.exports = __webpack_public_path__ + "static/media/map-serrazul-2.5266474e.png";